import { electronModule } from "@/modules/electron";
import { parseDesktopRealtimeEnvelope, ParsedDesktopEvent } from "./desktop-event-parser";

export type DesktopEventListener = (event: ParsedDesktopEvent) => void;

export function subscribeDesktopRealtime(listener: DesktopEventListener): () => void {
  let unsub: (() => void) | undefined;
  let disposed = false;

  const setUnsub = (candidate: unknown) => {
    if (typeof candidate !== "function") return;
    if (disposed) {
      try {
        candidate();
      } catch (_) {
        /* empty */
      }
      return;
    }
    unsub = candidate as () => void;
  };

  const callback = ({ event }: { event: unknown }) => {
    if (disposed) return;
    const parsed = parseDesktopRealtimeEnvelope({ event });
    if (parsed) listener(parsed);
  };

  try {
    const maybe = electronModule.recall.onEvent?.({ callback });
    if (
      maybe &&
      typeof (maybe as Promise<unknown>) === "object" &&
      typeof (maybe as Promise<unknown>).then === "function"
    ) {
      (maybe as Promise<unknown>).then(setUnsub).catch(() => undefined);
    } else {
      setUnsub(maybe);
    }
  } catch (_) {
    // bridge not available
  }
  return () => {
    disposed = true;
    try {
      unsub?.();
    } catch (_) {
      /* empty */
    }
  };
}
